import iconSet from './iconset.json'
import Icon from './Icon'

export { iconSet, Icon }

export default Icon
